import React from 'react';
import PropTypes from 'prop-types';

const DummyReactComponent = ({ text }) => (
  <div>
    This is a dummy react component.
    There is a text prop set to:&nbsp;
    {text}
  </div>
);

DummyReactComponent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default DummyReactComponent;
